import { computed, ref } from '@vue/composition-api';
import dayjs from 'dayjs';
import Vue from 'vue';
import store from '@/store';
import { ChargebackPreventionOrderServiceType } from '@/enums/chargeback-prevention/chargeback-prevention-order.enum';

const SERVICE_TYPE_LABEL = ChargebackPreventionOrderServiceType.reduce(
  (labels, { value, title }) => ({ ...labels, [value]: title }),
  {},
);

export default function usePreventIntegrations() {
  const loading = ref(false);
  const rows = ref([]);
  const expandedItems = ref([]);

  const merchantItems = computed(() => rows.value);

  function serviceTypeLabel(integration) {
    return SERVICE_TYPE_LABEL[integration.serviceType] || integration.serviceType;
  }

  function formatDateTime(value) {
    return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '-';
  }

  function fetchOverview() {
    loading.value = true;
    store
      .dispatch('chargebackPreventionIntegration/fetchOverview')
      .then(response => {
        rows.value = response.data.rows || [];
      })
      .catch(() => {
        Vue.notify({
          type: 'error',
          title: 'Prevent Integrations',
          text: 'Cannot fetch prevent integrations overview',
        });
      })
      .finally(() => {
        loading.value = false;
      });
  }

  fetchOverview();

  return {
    loading,
    rows,
    merchantItems,
    expandedItems,
    serviceTypeLabel,
    formatDateTime,
    fetchOverview,
  };
}
